/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Image, Space } from "antd";
import customStyles from "../../../../../../assets/styles/customStyles";
import crudActions from "../../../../../CRUD/redux/actions";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { taxSetupHead } from "../../../../../../config/constant";
import { TableCell, TableRow, Box, Typography, TextField, Button, FormControlLabel, Switch } from '@mui/material';
import usePrevious from "../../../../../Shared/components/Previous";
import { checkCRUDPermission, getColumnWidth } from "../../../../../../helpers/utilities";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import { emptyValidation } from "../../../../../../helpers/validation";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../../Shared/components/DeleteModal";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";


export const SetupList = React.forwardRef((props, ref) => {
    const { roleManagement, readDetails, customObject } = props;
    const { partyGstdetails } = useSelector(state => state.adminSetupReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { createDetails, createError, editDetails, editError, createLoader, editLoader } = useSelector(state => state.crudReducer);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const classes = customStyles();
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [addMore, setAddMore] = useState(false);
    const [view, setView] = useState(false);
    const [setupList, setSetupList] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [form, setForm] = useState({
        countryTaxId: readDetails?.id,
        isDefault: false
    });
    const [error, setError] = useState({});

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'tax-types',
            skip: skip,
            filter: {
                where: { countryTaxId: readDetails?.id },
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onRequestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const onDelete = (data) => {
        setForm(data);
        setDeleteVisible(true);
    }

    useImperativeHandle(ref, () => ({
        onLoad(data) {
            dispatchFilter(sortBy, sortOrder);
        }
    }))

    const handleOpen = (data, view) => {
        setForm(data);
        setError({});
        setView(view);
        setVisible(!visible);
    }

    const createSetup = (e) => {
        e.preventDefault();
        let emptyCode = emptyValidation('Tax Id', form?.taxCode);
        let emptyName = emptyValidation('Tax Name', form?.name);
        setError({});
        if (emptyCode.isValid && emptyName.isValid) {
            delete form.countryTax;
            delete form.partyGst;
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            dispatch({
                type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "tax-types",
                id: form.id,
                title: "Tax Types",
                details: data, method: 'put'
            });
            setSetupList(true);
        } else {
            setError({
                taxCode: emptyCode.errors,
                name: emptyName.errors
            });
        }
    }

    useEffect(() => {
        if (setupList) {

            if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
                dispatchFilter(sortBy, sortOrder);
                handleOpen({
                    countryTaxId: readDetails?.id,
                    isDefault: false
                }, false);
                toast.dismiss();
                setSetupList(false);
                toast(createDetails);
                if (addMore) {
                    setAddMore(false);
                    setTimeout(function () {
                        setVisible(true);
                    }, 500)
                }
                setSetupList(false);
            } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
                setSetupList(false);
                let text = createError.error.message;
                setError({
                    "taxCode": text
                })
            }
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (setupList) {
            if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
                setSetupList(false);
                dispatchFilter(sortBy, sortOrder);
                handleOpen({
                    countryTaxId: readDetails?.id,
                    isDefault: false
                }, false);
                toast.dismiss();
                toast(editDetails);
            } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
                setSetupList(false);
                let text = editError.error.message;
                setError({
                    "taxCode": text
                });
                setSetupList(false);
            }

        }
    }, [editDetails, editError]);

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            })
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            })
        }
    }

    return (
        <>
            <div className={classes.textAlignRight}>
                <NavLink
                    to={"#"}
                    onClick={() => handleOpen({
                        countryTaxId: readDetails?.id,
                        isDefault: false
                    }, false)}
                    className={clsx(classes.margin15b, classes.customLink)}>
                    <Image
                        src={AddIcon}
                        preview={false}
                        className={clsx(classes.antImage)}
                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                </NavLink>
            </div>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                loadMoreTask={loadMoreTask}
                heads={taxSetupHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                component={
                    <>
                        {
                            !loadMore || getList === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={taxSetupHead.length + 1}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        getList && Array.isArray(getList) && getList.length > 0 ? getList.map((data, i) => (
                                            <TableRow
                                                key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(taxSetupHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Tax Setup', 'view', 'Younote Admin') ?
                                                            <NavLink style={{ width: getColumnWidth(taxSetupHead, 0) }} to={"#"} onClick={() => handleOpen(data, true)} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>{data?.taxCode}</NavLink>
                                                            : <span style={{ width: getColumnWidth(taxSetupHead, 0) }}>{data?.taxCode || '---'}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(taxSetupHead, 1) }}><span style={{ width: getColumnWidth(taxSetupHead, 1) }}>{data?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(taxSetupHead, 2) }}><span style={{ width: getColumnWidth(taxSetupHead, 2) }}>{data?.isDefault ? 'Yes' : 'No'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(taxSetupHead, 3) }}><span style={{ width: getColumnWidth(taxSetupHead, 3) }}>{data?.partyGst?.code || '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Tax Setup', 'view', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => handleOpen(data, true)}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Tax Setup', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => handleOpen(data, false)}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Tax Setup', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={taxSetupHead.length + 1}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen({
                    countryTaxId: readDetails?.id,
                    isDefault: false
                }, false)}
                title={`${form?.id ? `${view ? 'View' : 'Edit'}` : 'Add'} Setup`}
                width={'360px'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createSetup(e)}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                <Col span={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Country</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.country?.name}</Typography>
                                </Col>
                                <Col span={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.name}</Typography>
                                </Col>
                                <Col span={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax Id</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.taxCode}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                label={["Tax Id ", <span key={"Tax Id"} className={classes.colorRedRequired}> *</span>]}
                                                variant={'standard'}
                                                error={error.taxCode ? true : false}
                                                helperText={error.taxCode}
                                                name={"taxCode"}
                                                fullWidth
                                                value={form?.taxCode}
                                                className={classes.margin30t}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col span={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.name}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                label={["Name ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                                variant={'standard'}
                                                error={error.name ? true : false}
                                                helperText={error.name}
                                                name={"name"}
                                                fullWidth
                                                value={form?.name}
                                                className={classes.margin30t}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col span={24}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Party Gst</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.partyGst?.code || '---'}</Typography>
                                        </> : <AutoCompleteComponent
                                            name={["Party Gst"]}
                                            heads={[{ 'key': 'code', 'name': 'Name' }]}
                                            details={partyGstdetails}
                                            parentValue={customObject(partyGstdetails, form?.partyGstId)}
                                            onChange={(data) => changeHandler(data.id, 'partyGstId')}
                                            onChangeText={(value) => {
                                                if (value === '') {
                                                    setForm({
                                                        ...form, partyGstId: value
                                                    })
                                                }
                                            }}
                                            position={"bottom"}
                                            customClasses={classes.margin30t}
                                            parentError={error?.countryId}
                                        />
                                    }
                                </Col>
                                <Col span={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.isDefault ? 'Yes' : 'No'}</Typography>
                                            </> : <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                                }}
                                                control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                    onChange={(e) => {
                                                        setForm({ ...form, 'isDefault': !form.isDefault })
                                                    }}
                                                />}
                                                label="Default"
                                                labelPlacement="top"
                                                checked={form?.isDefault}
                                                className={clsx(classes.marginLeft0, classes.margin30t, classes.flexStart)}
                                            />
                                    }
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                !view ?
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                form?.id ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                    </Space> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                            }
                        </div>
                    </Box>
                }
            />
            <DeleteModal
                onClose={(v) => setDeleteVisible(false)}
                id={form.id} loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={form?.name} url={'tax-types'}
                title={'Tax Types'} visible={deleteVisible} />
        </>
    )
})